import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AppsReviewCard from '../Applications/AppsReviewCard';
import Typography from "@material-ui/core/Typography";
import DocIcon from '../../icons/DocIcon';
import VideoIcon from '../../icons/VideoIcon';
import RateIcon from '../../icons/RateIcon';
import OutsourcingIcon from '../../icons/OutsourcingIcon';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { Link, useParams } from "react-router-dom"
import CardManager from '../CardManager';
import translate from '../../other/translate.json'
import axios from 'axios';
import SkeletonReviewContent from '../Skeleton/SkeletonReviewContent';
import SkeletonGroups from '../Skeleton/SkeletonGroups';
import config from '../../other/config';
const {serverAPI} = config;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
          <Grid id="a157">{children}</Grid>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function ProdReviewContent(props) {
  const classes = useStyles();
  const wide = false;
  //const [bankinfo, setBankinfo] = useState([]);
  const {bankinfo} = props   
  const [directions, setDirections] = useState([]);
  const [loading, setloading] = React.useState(true);
  const language = localStorage.getItem('language') || 'Ru'

  let IsRu = language === 'Ru'
  let lang = language
  let { bank } = useParams();
  
  useEffect(() => {
    let didCancel = false;
    async function fetchData() {
      setloading(true)
      //const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/2/${language}`)
      const _directions = await axios.get(`${serverAPI}/groupv/${language}?systema=${bank}`)
      // const _directions = await axios.get(`${serverAPI}/group_v2?systema=${bank}`)
      // const _actions = await axios.get(`${serverAPI}/actions/${bank}/${lang}`)
      if (!didCancel) {
        //if (_bankinfo && _bankinfo.data) {
          setloading(false)
          //setBankinfo(_bankinfo.data[0])
          setDirections(_directions.data)
          // setActions(_actions.data)
        //}
      }
    }
    fetchData();
    return () => {
      didCancel = true;
    }
  }, []);

  // useEffect(() => {
  //   let didCancel = false;
  //   async function fetchData() {
  //     const dataCard1 = await getArrCard(1)
  //     if (!didCancel) {
  //       if (dataCard1 && dataCard1.data)
  //         setCardArr(dataCard1.data.records)
  //     }
  //   }
  //   fetchData();
  //   return () => {
  //     didCancel = true;
  //   };

  // }, [reload]);

  // const [lastScrollTop, setLastScrollTop] = useState(0);
  // const [bodyOffset, setBodyOffset] = useState(
  //   document.body.getBoundingClientRect()
  // );
  // const [scrollY, setScrollY] = useState(bodyOffset.top);
  // const [scrollX, setScrollX] = useState(bodyOffset.left);
  // const [scrollDirection, setScrollDirection] = useState();

  // let actionJSONLength = 2 /* ДЛИННА JSON С АКЦИЯМИ */

  return (
    <React.Fragment>
      {/* <TabPanel value={value} index={1}> */}
      <Grid container style={{ marginTop: 85 }}>
        {loading === true
          ?
          <SkeletonReviewContent />
          :
          <Grid container direction="row" justify="space-between" alignItems="flex-start" className={classes.container}>
            <Grid item className={classes.serviceDescription}>
              <Typography component="p" className={classes.Body1} dangerouslySetInnerHTML={{ __html: bankinfo[`HTMLContent`] }}></Typography>
            </Grid>

            <Grid item className={classes.SideActions}>
              {
                IsRu && bankinfo.AboutPath && bankinfo.AboutPath.length > 4
                  ?
                  <a className={classes.link} href={`${serverAPI}/${bankinfo.HashCode}/about/${bankinfo.AboutPath}`} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row">
                      <DocIcon fill={'#BCBBD0'} />

                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        Информация по каталогу
                    </Typography>
                    </Grid>
                  </a>
                  :
                  ''
              }

              {
                IsRu && bankinfo.VideoPath && bankinfo.VideoPath.length > 4
                  ?
                  <a className={classes.link} href={`${serverAPI}/${bankinfo.HashCode}/video/${bankinfo.VideoPath}`} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row" style={{ marginTop: 20 }}>
                      <VideoIcon fill={'#BCBBD0'} />

                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        Видео презентация
                    </Typography>
                    </Grid>
                  </a>
                  :
                  ''
              }

              {
                bankinfo.Outsourcing && bankinfo.Outsourcing.length > 4
                  ?
                  <a className={classes.link} href={bankinfo.Outsourcing} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row" style={{ marginTop: 20 }}>
                      <RateIcon fill={'#BCBBD0'} />

                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        {translate.Words[`Outsourcing_${language}`]}
                      </Typography>
                    </Grid>
                  </a>
                  :
                  ''
              }

              {
                bankinfo.Tariff && bankinfo.Tariff.length > 4
                  ?
                  <a className={classes.link} href={bankinfo.Tariff} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row" style={{ marginTop: 20 }}>
                      <OutsourcingIcon fill={'#BCBBD0'} />

                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        {translate.Words[`PricePlans_${language}`]}
                      </Typography>
                    </Grid>
                  </a>
                  :
                  ''
              }
            </Grid>
          </Grid>
        }

        <Grid container style={{ marginTop: 64 }}>
          <Typography className={classes.Title2}>{translate.Words[`ProductGroups${language}`]}</Typography>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: 14 }}>
          {
            loading === true
              ?
              <SkeletonGroups />
              :
              directions && directions.length > 0
                ?
                directions.map((item, index) => {
                  return (
                    <Grid item style={{ width: 336 }} key={`${item.ID}_grid_key`}>
                      <Link className={classes.link} to={`/products/${bank}/prodlist?group=${item.ID}`}>
                        <AppsReviewCard
                          iconsCategory={'prod'}
                          key={`appcardkey_${item.ID_BN}`}
                          data={item}
                          wide={wide}
                        />
                      </Link>
                    </Grid>
                  )
                })
                :
                translate.Words[`PleaseChangeYourRequest${lang}`] 
          }
        </Grid>
      </Grid>

      {/* <Grid item xs={12} className={classes.block} style={{ marginTop: 82 }}>
        <Grid item>

          </Grid>

        <Grid item xs={12}>
            <Grid container className={classes.container} spacing={3} style={{ outline: '1px solid red', maxHeight: 504, overflow: 'hidden' }}>
              <Grid container className={classes.container} spacing={3} style={{ marginTop: -14, overflowY: 'auto' }}>
                <Grid item container direction="column" justify="flex-start" alignItems="flex-start" style={{ width: 336 }}>
                  <Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader}>
                    Новинки
					        </Typography>

                  <Typography component="p" className={classes.Body1} style={{ height: 382, marginTop: 24 }}>Согласно данным различных рейтингов ГК Центр Финансовых технологий входит в число крупнеших ИТ - компаний РФ, по многим показателям является лидером российского рынка разработчиков ПО для фин</Typography>
                  <Typography component="p" className={classes.Body1}>Посмотреть весь список</Typography>
                </Grid> 
                {cardArr && cardArr.length > 0
                  ?
                  cardArr.map((item, index) => (
                    <Grid item style={{ width: 336 }} key={`${item.ID}_grid_key`}>
                      <Link to={`./applist?cftbank&app=${item.CodeAsvul}`} style={{ textDecoration: 'none' }} >
                        <AppListCard
                          IsRu={IsRu}
                          key={`appcardkey_${item.ID}`}
                          data={item}
                          wide={wide}
                        />
                      </Link>
                    </Grid>
                  ))
                  : 'Измените запрос'
                }
              </Grid>
            </Grid>
          </Grid>
      </Grid> */}

      {
       bankinfo &&  bankinfo[`Managers`]
          ?
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="flex-start"
            className={classes.container}
          >
            <Grid item container className={classes.block}>
              <Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ textAlign: 'center', width: '100%' }}>
                {translate.Words[`ReadytoAnswerYourQuestions${lang}`]}:
							</Typography>

              <Grid
                item
                container
                direction="row"
                justify="center"
                alignItems="flex-start"
                spacing={3}
                style={{ marginTop: 40 }}
              >
                {
                  bankinfo[`Managers`] ? bankinfo[`Managers`].split(';#;').map((item, index) => (
                    <Grid item>
                      <CardManager data={item} />
                    </Grid>
                  ))
                    :
                    ''
                }
              </Grid>
            </Grid>
          </Grid>
          :
          ''
      }
      {/* </TabPanel> */}
    </React.Fragment>
  );
}

const useStyles = makeStyles(theme => ({
  contentHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '28px',
    lineHeight: '40px',
    textAlign: 'center',
    color: '#000000'
  },

  footer: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    padding: '36px 0'
  },

  tHeader: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    fontWeight: 400
  },

  root: {
    flexGrow: 1
  },

  padding: {
    padding: theme.spacing(1)
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#24262A'
  },

  Title2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: '#000000'
  },

  link: {
    textDecoration: 'none'
  },

  serviceDescription: {
    padding: '11px 0px',
    maxWidth: 865,

    [theme.breakpoints.between(1032, 1702)]: {
      maxWidth: 670,
    },

    [theme.breakpoints.down(1032)]: {
      maxWidth: '100%'
    },
  },

  SideActions: {
    minWidth: 246,
    padding: '12px 26px',
    // width: 313,
    marginTop: 17,

    [theme.breakpoints.down(1032)]: {
      padding: 0,
      // marginBottom: 60,
    }
  },
}));
